<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="title"
    class="!max-w-[764px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[8px] pb-[12px]">
        <div v-if="props.description">
          {{ props.description }}
        </div>
        <div
          v-for="(file, index) in props.files"
          v-bind:key="`file-${index}`"
          class="self-stretch">
          <refonte-label v-bind:label="file.periode" />
          <refonte-item-file-formateur-contrat-line
            v-bind:id="`contrat-${index}`"
            v-bind:on_close="props.on_close"
            v-bind:on_submit="props.on_submit"
            v-bind:participant_nom_prenom="props.participant_nom_prenom"
            v-bind:session_date="props.session_date"
            v-bind:formation_title="''"
            v-bind:contrat="file" />
        </div>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteLabel from '@/components/refonte/inputs/refonte-label.vue';
  import RefonteItemFileFormateurContratLine from '@/components/refonte/items/refonte-item-file-formateur-contrat-line.vue';
  import { Contrat } from '@/types/gestion/contrats-types';

  export interface ModalFile {
    formation?: string;
    title?: string;
    subtitle?: string;
    signed?: boolean;
    validee?: boolean;
    id?: number;
  }

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      on_submit?: Function;
      title?: string;
      files: Contrat[];
      file_on_click_download?: Function;
      participant_nom_prenom?: string;
      session_date?: string;
      class?: string;
      description?: string;
    }>(),
    {
      title: 'Document',
      file_signed_label: 'Signé',
      file_to_sign_label: 'A signer',
      file_no_signature_needed: false,
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
